import { useSelector } from 'react-redux';
import { IStore } from 'store/interface';
import { getStorePage } from '../../selector';

export const useStorePage = () => ({
  page: useSelector<IStore, number>(getStorePage),
});
